//////////////////////////////// LOCALIZATION
var defaultLocale;
if (localStorage.getItem('lang')) {
    defaultLocale = localStorage.getItem('lang');
} else {
    let timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    if (timeZone.includes('Tbilisi')) {
        defaultLocale = 'ka';
    } else {
        defaultLocale = 'en';
    }
}
let locale,
    commonTranslations = {},
    pageTranslations = {},
    translations = {};

document.addEventListener('DOMContentLoaded', () => {
    setLocale(defaultLocale);

    document
        .querySelectorAll('#navbar .active')
        .forEach((el) => el.classList.remove('active'));

    let titleEl = document.getElementById('page-title');

    switch (location.pathname) {
        // case '/':
        //     document.getElementById('home').classList.add('active');
        //     break;
        case '/about':
            document.getElementById('about').classList.add('active');
            titleEl.setAttribute('i18n-key', 'title_about');
            break;
        case '/why-dighomi-city':
            document.getElementById('why-dighomi-city').classList.add('active');
            titleEl.setAttribute('i18n-key', 'title_why_us');
            break;
        case '/shops':
            document.getElementById('shops').classList.add('active');
            titleEl.setAttribute('i18n-key', 'title_shops');
            break;
        case '/gallery':
            document.getElementById('gallery').classList.add('active');
            titleEl.setAttribute('i18n-key', 'title_gallery');
            break;
        case '/mall-map':
            document.getElementById('mall-map').classList.add('active');
            titleEl.setAttribute('i18n-key', 'title_mall_map');
            break;
        case '/services':
            document.getElementById('services').classList.add('active');
            titleEl.setAttribute('i18n-key', 'title_services');
            break;
        case '/contact':
            document.getElementById('contact').classList.add('active');
            titleEl.setAttribute('i18n-key', 'title_contact');
        case '/apizza':
            document.getElementById('apizza').classList.add('active');
            titleEl.setAttribute('i18n-key', 'title_apizza');
            break;
        default:
            break;
    }
});

function setLocale(newLocale) {
    if (newLocale === locale) return;
    Promise.all([
        fetchTranslationsFor(newLocale),
        fetchPageTranslationsFor(location.pathname, newLocale),
    ]).then((res) => {
        locale = newLocale;
        translations = { ...res[0], ...res[1] };
        translatePage();
        document
            .querySelectorAll('.lang-switcher .active-lang')
            .forEach((el) => el.classList.remove('active-lang'));

        document.querySelectorAll('a.logo').forEach((logoEl) => {
            logoEl.innerHTML = `<img src="../assets/logo_${newLocale}.svg" alt="Dighomi City Logo">`;
        });

        document.querySelectorAll('#apizza > div').forEach((div) => {
            if (div.lang === newLocale) {
                div.style.display = 'block';
            } else {
                div.style.display = 'none';
            }
        });

        document.querySelector(`#${newLocale}`).classList.add('active-lang');
        localStorage.setItem('lang', newLocale);
    });
}

async function fetchTranslationsFor(newLocale) {
    const response = await fetch(`/getTranslations/${newLocale}`);
    return await response.json();
}

async function fetchPageTranslationsFor(page, newLocale) {
    if (page === '/') {
        page = '/home';
    }
    const response = await fetch(`/getPageTranslations${page}/${newLocale}`);
    return await response.json();
}

function getSingleTranslation(key) {
    return translations[key] || '';
}

function translatePage() {
    document.querySelectorAll('[i18n-key]').forEach(translateElement);
}

function translateElement(element) {
    const key = element.getAttribute('i18n-key');
    const translation = translations[key];
    element.innerHTML = translation;
}

function OpenCategories() {
    document.querySelector('.nav-cats').classList.add('shown');
    document.querySelector('.nav-slideout-dim-background').style.display =
        'block';
}

function CloseCategories() {
    document.querySelector('.nav-cats').classList.remove('shown');
    document.querySelector('.nav-slideout-dim-background').style.display =
        'none';
}

function roomHover(e, key, isUnavailable = false) {
    let parentSlide = e.closest('.swiper-slide');
    let textEl = parentSlide.querySelector('.room-desc');
    textEl.setAttribute('i18n-key', key);
    translateElement(textEl);

    if (isUnavailable) {
        textEl.classList.add('unavailable-desc');
    } else {
        textEl.classList.remove('unavailable-desc');
    }
}

function clearRoomDesc() {
    document.querySelectorAll('.room-desc').forEach((el) => {
        el.innerHTML = '';
        el.removeAttribute('i18n-key');
    });
}
////////////////////////////////////////////////
